// Available customization options.
// Keep IDs unchanged when adding new options later.

export const avatarOptions = {
  characterType: [
    { id: 'human_male', label: 'Male' },
    { id: 'human_female', label: 'Female' },
  ],


  head: [
    { id: 'circle', label: 'Round' },
    { id: 'square', label: 'Rounded square' },
    { id: 'oval', label: 'Oval' },
    { id: 'heart', label: 'Heart' },
    { id: 'diamond', label: 'Diamond' },
    { id: 'oblong', label: 'Oblong' },
  ],

  skinTone: [
    {
      id: 'skin_04',
      label: 'Porcelain',
      color: '#FFE4D3',
      shadow: '#E6BEA7',
    },
    {
      id: 'skin_05',
      label: 'Fair',
      color: '#FAD8BC',
      shadow: '#DFB292',
    },
    {
      id: 'skin_01',
      label: 'Light',
      color: '#F5C9A5',
      shadow: '#DFA780',
    },
    {
      id: 'skin_06',
      label: 'Warm beige',
      color: '#E9B58E',
      shadow: '#C98E66',
    },
    {
      id: 'skin_07',
      label: 'Golden tan',
      color: '#DCA171',
      shadow: '#B77C50',
    },
    {
      id: 'skin_02',
      label: 'Medium',
      color: '#C98958',
      shadow: '#A96940',
    },
    {
      id: 'skin_08',
      label: 'Warm brown',
      color: '#AD744E',
      shadow: '#895536',
    },
    {
      id: 'skin_09',
      label: 'Rich brown',
      color: '#925F42',
      shadow: '#70432D',
    },
    {
      id: 'skin_03',
      label: 'Deep',
      color: '#754B36',
      shadow: '#553324',
    },
    {
      id: 'skin_10',
      label: 'Deepest',
      color: '#503329',
      shadow: '#352019',
    },
  ],


  expression: [
    { id: 'happy_01', label: 'Happy' },
    { id: 'sad_01', label: 'Sad' },
    { id: 'angry_01', label: 'Angry' },
    { id: 'shocked_01', label: 'Shocked' },
    { id: 'cool_01', label: 'Cool' },
    { id: 'crying_01', label: 'Crying' },
    { id: 'wink_01', label: 'Wink' },
    { id: 'laughing_01', label: 'Laughing' },
    { id: 'love_01', label: 'Love' },
    { id: 'cheeky_01', label: 'Cheeky' },
    { id: 'sleepy_01', label: 'Sleepy' },
  ],

  eyeShape: [
    { id: 'oval_01', label: 'Oval' },
    { id: 'almond_01', label: 'Almond' },
    { id: 'round_01', label: 'Round' },
    { id: 'narrow_01', label: 'Narrow' },
    { id: 'hooded_01', label: 'Hooded' },
  ],

  // Selected independently from eye shape.
  eyeColor: [
    {
      id: 'eye_color_01',
      label: 'Classic dark',
      color: '#292332',
    },
    {
      id: 'eye_color_02',
      label: 'Dark brown',
      color: '#54392D',
    },
    {
      id: 'eye_color_03',
      label: 'Brown',
      color: '#956039',
    },
    {
      id: 'eye_color_04',
      label: 'Hazel',
      color: '#96904D',
    },
    {
      id: 'eye_color_05',
      label: 'Green',
      color: '#528462',
    },
    {
      id: 'eye_color_06',
      label: 'Blue',
      color: '#508FBD',
    },
    {
      id: 'eye_color_07',
      label: 'Grey',
      color: '#87939F',
    },
  ],



  hair: [
    { id: 'bald', label: 'Bald' },
    {
      id: 'short_01',
      label: 'Short',
      color: '#292332',
      highlight: '#42394E',
    },
    { id: 'fade_01', label: 'Fade' },
    { id: 'mohawk_01', label: 'Mohawk' },
    { id: 'balding_01', label: 'Balding sides' },
    { id: 'curl_01', label: 'Single curl' },
    { id: 'puffs_01', label: 'Double puffs' },

    { id: 'waves_01', label: 'Long waves' },
    { id: 'braids_01', label: 'Twin braids' },
    { id: 'side_braid_01', label: 'Side braid' },
    { id: 'bun_01', label: 'High bun' },
    { id: 'bob_01', label: 'Bob' },

  ],

  // Selected independently from hairstyle.
  hairColor: [
    {
      id: 'hair_color_01',
      label: 'Midnight',
      color: '#292332',
      highlight: '#42394E',
    },
    {
      id: 'hair_color_02',
      label: 'Dark brown',
      color: '#493026',
      highlight: '#705040',
    },
    {
      id: 'hair_color_03',
      label: 'Chestnut',
      color: '#78472F',
      highlight: '#A46A48',
    },
    {
      id: 'hair_color_04',
      label: 'Copper',
      color: '#AD542F',
      highlight: '#D8804B',
    },
    {
      id: 'hair_color_05',
      label: 'Golden blonde',
      color: '#D7A447',
      highlight: '#F2CD76',
    },
    {
      id: 'hair_color_06',
      label: 'Platinum',
      color: '#D9D2C3',
      highlight: '#F5EFE3',
    },
    {
      id: 'hair_color_07',
      label: 'Silver',
      color: '#9098AA',
      highlight: '#C3CBD8',
    },
    {
      id: 'hair_color_08',
      label: 'Purple',
      color: '#7546B8',
      highlight: '#A477E0',
    },
    {
      id: 'hair_color_09',
      label: 'Blue',
      color: '#326AB5',
      highlight: '#65A0E3',
    },
    {
      id: 'hair_color_10',
      label: 'Pink',
      color: '#C65186',
      highlight: '#EE87B4',
    },
  ],


  clothing: [
    {
      id: 'tshirt_01',
      label: 'Classic tee',
      color: '#7060E8',
      shadow: '#5143B8',
      highlight: '#9486F5',
    },
    { id: 'hoodie_01', label: 'Hoodie' },
    { id: 'shirt_01', label: 'Collared shirt' },
    { id: 'jacket_01', label: 'Jacket' },
    { id: 'sleeveless_01', label: 'Sleeveless top' },
  ],

  // Selected independently from clothing style.
  clothingColor: [
    {
      id: 'clothing_color_01',
      label: 'Purple',
      color: '#7060E8',
      shadow: '#5143B8',
      highlight: '#9486F5',
    },
    {
      id: 'clothing_color_02',
      label: 'Blue',
      color: '#3985DF',
      shadow: '#2562AE',
      highlight: '#70AAF1',
    },
    {
      id: 'clothing_color_03',
      label: 'Teal',
      color: '#279F99',
      shadow: '#197670',
      highlight: '#60C7BF',
    },
    {
      id: 'clothing_color_04',
      label: 'Green',
      color: '#57A867',
      shadow: '#397C47',
      highlight: '#87CB92',
    },
    {
      id: 'clothing_color_05',
      label: 'Yellow',
      color: '#EFC44D',
      shadow: '#C39A2D',
      highlight: '#FFE08A',
    },
    {
      id: 'clothing_color_06',
      label: 'Orange',
      color: '#ED914A',
      shadow: '#C46A2F',
      highlight: '#FFB878',
    },
    {
      id: 'clothing_color_07',
      label: 'Red',
      color: '#DA5B60',
      shadow: '#AC3C45',
      highlight: '#F38C90',
    },
    {
      id: 'clothing_color_08',
      label: 'Pink',
      color: '#DB78AF',
      shadow: '#AE5186',
      highlight: '#F3A6CF',
    },
    {
      id: 'clothing_color_09',
      label: 'Ivory',
      color: '#EEEAE2',
      shadow: '#C8C2B7',
      highlight: '#FFFCF6',
    },
    {
      id: 'clothing_color_10',
      label: 'Charcoal',
      color: '#343746',
      shadow: '#222430',
      highlight: '#565B70',
    },
  ],

  background: [
    { id: 'bg_01', label: 'Lavender', color: '#E9E3FF' },
    { id: 'bg_02', label: 'Mint', color: '#D8F3E5' },
    { id: 'bg_03', label: 'Peach', color: '#FFE4D2' },
    { id: 'bg_04', label: 'Sky', color: '#DDEEFF' },
    { id: 'bg_05', label: 'Rose', color: '#FADDEA' },
    { id: 'bg_06', label: 'Butter', color: '#FFF1C7' },
    { id: 'bg_07', label: 'Aqua', color: '#D5F2F2' },
    { id: 'bg_08', label: 'Lilac', color: '#F0DFFF' },
    { id: 'bg_09', label: 'Sand', color: '#EDE3D5' },
    { id: 'bg_10', label: 'Slate', color: '#CDD5E5' },
  ],
};


// Controls the order of categories in the creator.
// Color controls appear inside Eyes, Hair and Clothes.
export const avatarCategories = [
  { id: 'characterType', label: 'Character' },
  { id: 'head', label: 'Head' },
  { id: 'skinTone', label: 'Skin' },
  { id: 'eyeShape', label: 'Eyes' },
  { id: 'expression', label: 'Expression' },
  { id: 'hair', label: 'Hair' },
  { id: 'clothing', label: 'Clothes' },
  { id: 'background', label: 'Background' },
];

// Unknown IDs fall back to the category's first option.
export function getAvatarOption(category, optionId) {
  const options = avatarOptions[category];

  if (!options || options.length === 0) {
    return null;
  }

  return (
    options.find((option) => option.id === optionId) ||
    options[0]
  );
}
